import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useApiFetch } from '../../shared/api'

export interface GenerateJoinCodeResponse {
  joinCode: string
}

/**
 * Generate (or regenerate) a team's join code via the REST BFF
 * (POST /clubhouse/groups/{groupId}/join-code). Owner/Administrator only —
 * enforced server-side; the UI additionally hides the control from other roles.
 *
 * The server mints a fresh, unique `LLLNNN` code and returns it. We invalidate
 * the my-groups query so the code re-reads from its source of truth
 * (`GroupDto.joinCode`) and every surface reflects the new value.
 */
export function useGenerateJoinCode(groupId: string) {
  const call = useApiFetch()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () =>
      call<GenerateJoinCodeResponse>(`/clubhouse/groups/${encodeURIComponent(groupId)}/join-code`, {
        method: 'POST',
      }),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['clubhouse', 'me', 'groups'] })
    },
  })
}
